import React, { useContext } from 'react'
import { FormContext } from '../../FormContext';

const Navbar = ({ formBar=false, formBack,formId }) => {

  const {formNavLabel} = useContext(FormContext)
  //console.log('formId in navbar',formId)
  const backToFormSearch = () => {
    window.location.href = formBack;
  }

  const renderNav = formBar ? (<nav className="main-header navbar navbar-expand navbar-dark navbar-success">
    <ul className="navbar-nav">
      <li className="nav-item nav-item-home">
        <a className="nav-link-home" style={{ cursor: "pointer",paddingRight:"1rem", paddingLeft:"1rem", color:"#FFFFFF" }} onClick={backToFormSearch}><i className="fas fa-arrow-left" /> &nbsp;&nbsp;<font style={{fontSize:20,lineHeight:20}}>{formNavLabel? formNavLabel: formId?formId:null}</font></a>
      </li>
    </ul>

  </nav>) : null
  return (
    renderNav

  )
}

export default Navbar
